import { render, staticRenderFns } from "./TheSideMenu.vue?vue&type=template&id=4babc88d&scoped=true&"
import script from "./TheSideMenu.vue?vue&type=script&lang=js&"
export * from "./TheSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheSideMenu.vue?vue&type=style&index=0&id=4babc88d&lang=scss&scoped=true&"
import style1 from "./TheSideMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4babc88d",
  null
  
)

export default component.exports